import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
import SvgColor from 'src/components/svg-color';
// import { useSelector } from 'react-redux';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import Iconify from 'src/components/iconify';
import Label from 'src/components/label';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  giveaway: icon('ic_giveaway'),
  termsAndConditions: icon('ic_terms'),
  privacyPolicy: icon('ic_privacy'),
  customer: icon('ic_users'),
  organizers: icon('ic_organizer'),
  category: icon('ic_category'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();
  const { user } = useMockedUser();


  const ORGANIZER_MENU = [
    {
      subheader: t("home.Organizer"),
      items: [
        { title: t("home.dashboard"), path: paths.orangizerDashboard.root, icon: ICONS.dashboard },
        { title: t("home.giveaway"), path: paths.orangizerDashboard.organizersGiveaway, icon: ICONS.ecommerce },
      ],
    },
  ];
  const SUPER_ADMIN_MENU = [
    {
      subheader: t('home.super_admin'),
      items: [
        {
          title: t('home.dashboard'),
          path: paths.superAdminDashboard.root,
          icon: ICONS.dashboard,
        },
        {
          title: t('home.ads_management'),
          path: paths.superAdminDashboard.adsManagement,
          icon: ICONS.analytics,
        },
        {
          title: t('home.clients'),
          path: paths.superAdminDashboard.clients,
          icon: ICONS.user,
        },
        {
          title: t('home.users'),
          path: paths.superAdminDashboard.userss,
          icon: ICONS.customer,
        },
        {
          title: t('home.categories'),
          path: paths.superAdminDashboard.category,
          icon: ICONS.category,
        },
        {
          title: t('home.giveaway'),
          path: paths.superAdminDashboard.giveaway.root,
          icon: ICONS.ecommerce,
        },
        {
          title: t('home.organizers'),
          path: paths.superAdminDashboard.organizers,
          icon: ICONS.organizers,
        },

        {
          title: t('home.contact_us'),
          path: paths.superAdminDashboard.contactUs,
          icon: ICONS.chat,
        },
        {
          title: t('home.faqs'),
          path: paths.superAdminDashboard.faqss,
          icon: ICONS.tour,
        },
        {
          title: t('home.about_us'),
          path: paths.superAdminDashboard.aboutt,
          icon: ICONS.blog,
        },
        {
          title: t('home.terms_and_conditions'),
          path: paths.superAdminDashboard.termsAndConditions,
          icon: ICONS.termsAndConditions,
        },

        {
          title: t('home.privacy_policy'),
          path: paths.superAdminDashboard.privacyPolicy,
          icon: ICONS.privacyPolicy,
        },
        // {
        //   title: t('ecommerce'),
        //   path: paths.dashboard.general.ecommerce,
        //   icon: ICONS.ecommerce,
        // },
        // {
        //   title: t('analytics'),
        //   path: paths.dashboard.general.analytics,
        //   icon: ICONS.analytics,
        // },
        // {
        //   title: t('banking'),
        //   path: paths.dashboard.general.banking,
        //   icon: ICONS.banking,
        // },
        // {
        //   title: t('booking'),
        //   path: paths.dashboard.general.booking,
        //   icon: ICONS.booking,
        // },
        // {
        //   title: t('file'),
        //   path: paths.dashboard.general.file,
        //   icon: ICONS.file,
        // },
      ],
    },
  ]
  const USER_MENU = [
    {
      subheader: t('home.User'),
      items: [
        {
          title: t('home.dashboard'),
          path: paths.dashboard.root,
          icon: ICONS.dashboard,
        },
        {
          title: t('home.giveaway'),
          path: paths.dashboard.giveaway.root,
          icon: ICONS.giveaway,
          children: [
            {
              title: t('home.participated_in'),
              path: paths.dashboard.giveaway.participatedIn,
            },
            {
              title: t('home.participate'),
              path: paths.dashboard.giveaway.participate
            },
            {
              title: t('home.upcoming_draw'),
              path: paths.dashboard.giveaway.upcomingDraw
            },
          ]
        },
        // {
        //   title: t("Demo"),
        //   path: paths.dashboard.demo.root,
        //   icon: ICONS.blog,
        //   children: [
        //     {
        //       title: t("Live Draw Wheel"),
        //       path: paths.dashboard.demo.liveDrawwheel
        //     },
        //     {
        //       title: t("Result Wheel"),
        //       path: paths.dashboard.demo.resultWheel
        //     },
        //     {
        //       title: t("Live Draw Slot Machine"),
        //       path: paths.dashboard.demo.liveDrawslotMachinep
        //     },
        //     {
        //       title: t("Result Slot Machine"),
        //       path: paths.dashboard.demo.resultSlotMachine
        //     },
        //     {
        //       title: t("Live Draw MyStery Box"),
        //       path: paths.dashboard.demo.liveDrawmysteryBox
        //     },
        //     {
        //       title: t("Result MyStery Box"),
        //       path: paths.dashboard.demo.resultMysteryBox
        //     },
        //     {
        //       title: t("Live Draw Reel Spin"),
        //       path: paths.dashboard.demo.liveDrawreelSpin
        //     },
        //     {
        //       title: t("Result Reel Spin"),
        //       path: paths.dashboard.demo.resultReelSpin
        //     },
        //     {
        //       title: t("Live Draw Flip Card"),
        //       path: paths.dashboard.demo.liveDrawflipCard,

        //     },
        //     {
        //       title: t("Result Flip Card"),
        //       path: paths.dashboard.demo.resultFlipCard
        //     },
        //     {
        //       title: t("Live Draw Ticker Tape"),
        //       path: paths.dashboard.demo.liveDrawTickerTap
        //     },
        //     {
        //       title: t("Result Ticker Tape"),
        //       path: paths.dashboard.demo.resultTickerTap
        //     }
        //   ]
        // }

      ]
    }]

  const newData = useMemo(() => {
    if (user?.userType === 'super-admin' || user?.role === "super-admin") return SUPER_ADMIN_MENU;
    if (user?.userType === 'organizer') return ORGANIZER_MENU;
    return USER_MENU;
  }, [user, SUPER_ADMIN_MENU, ORGANIZER_MENU, USER_MENU]);
  return newData;

  // return data;
}
